export const VALIDA_ACTION = 'VALIDA_ACTION';
export const REMOVE_VALIDATION = 'REMOVE_VALIDATION';